import React from 'react';
import { BedIcon, CalendarRangeIcon, CompassIcon, ClipboardListIcon, MoonIcon, RefreshCwIcon, ShieldCheckIcon, TimerIcon, MoonStarIcon } from 'lucide-react';
import { CtaBlock, CtaButton } from '../components/CtaButton';
import { FaqItem } from '../components/FaqItem';
import { InsidePages } from '../components/InsidePages';
import { StickyCta } from '../components/StickyCta';
import { GUARANTEE_TEXT, GUARANTEE_TITLE, faqs, guides, heroBenefits, offerIncludes, painPoints, testimonials } from '../data/content';
const MOCKUP_URL = 'https://cdn.magicpatterns.com/uploads/3mwrhkUoCDtynSAjfGyryU/mockup2.png';
const LIFESTYLE_URL = 'https://cdn.magicpatterns.com/patterns/generated-images/e6a6c5cf-96a0-4b94-b2be-7cd50b5302df.jpg';
const benefitIcons = [CompassIcon, ClipboardListIcon, CalendarRangeIcon];
const painIcons = [TimerIcon, MoonIcon, BedIcon, RefreshCwIcon];
const OFFER_META = 'Instant Digital Access • 6 Digital Guides • One-Time Payment';
export function SalesPage() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-brand-ivory font-body text-brand-charcoal" data-id="element-34" data-mp="3ak8cq8e99jo8">
      {/* Header */}
      <header className="border-b border-brand-charcoal/10 bg-brand-ivory" data-id="element-35" data-mp="35ryoqxwpatol">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-2.5 lg:px-8" data-id="element-36" data-mp="30tdqh410ek2s">
          <p className="font-body text-[11px] font-semibold uppercase tracking-[0.22em] text-brand-charcoal" data-id="element-37" data-mp="2vvc5uenxqcp7">
            Prof.Kyra
          </p>
          <div className="flex items-center gap-4" data-id="element-38" data-mp="3tht1lfh0si8u">
            
            <CtaButton label="Get Access" size="md" className="hidden px-4 py-2 text-[11px] md:inline-flex" data-id="element-39" data-mp="3okj5jgz4l8c1" />
          </div>
        </div>
      </header>

      <main data-id="element-40" data-mp="3jm9b58l86brh">
        {/* 01 — HERO */}
        <section className="bg-brand-ivory px-5 pb-14 pt-10 lg:px-8 lg:pb-20 lg:pt-14" data-id="element-41" data-mp="3fjky0ophaiop">
          <div className="mx-auto max-w-3xl text-center" data-id="element-42" data-mp="285rdj55w6339">
            <p className="flex items-center justify-center gap-2 font-body text-[11px] font-medium uppercase tracking-[0.2em] text-brand-charcoal/55" data-id="element-43" data-mp="2835573b6fjjz">
              <MoonStarIcon className="h-3.5 w-3.5 text-brand-charcoal/40" strokeWidth={1.25} aria-hidden="true" data-id="element-44" data-mp="25kjsocdkyvx2" />
              Real Solutions for Tired Parents
            </p>
            <h1 className="mt-5 font-display text-[2.3rem] font-bold leading-[1.06] tracking-[-0.01em] text-brand-charcoal sm:text-[3rem] lg:text-[3.5rem]" data-id="element-45" data-mp="1vmvxxmfz5oew">
              Tired of 20-Minute Naps, Bedtime Battles &amp; Constant Night Wakings?
            </h1>
            <p className="mx-auto mt-5 max-w-2xl text-[15px] leading-relaxed text-brand-charcoal/70 sm:text-base" data-id="element-46" data-mp="1mt0uqjyey81w">
              Stop guessing when your baby should sleep. Get age-by-age wake windows, nap times and
              simple routines to build calmer, more predictable sleep from birth to 24 months.
            </p>
          </div>

          {/* Product — warm halo so the mockup sits in the page, not on top of it */}
          <div className="relative mx-auto mt-10 w-full max-w-[600px] lg:mt-12" data-id="element-47" data-mp="17x1m987e65w8">
            <div aria-hidden="true" className="absolute left-1/2 top-[54%] h-[64%] w-[86%] -translate-x-1/2 -translate-y-1/2 rounded-[50%] bg-brand-oatmeal opacity-70 blur-2xl" data-id="element-48" data-mp="17yvyzz8ierp8" />
            <img src={MOCKUP_URL} alt="The Baby Sleep Bible by Prof. Kyra — the complete set of six digital sleep guides" className="relative mx-auto block w-full max-w-[360px] object-contain lg:max-w-[560px]" style={{
            filter: 'drop-shadow(0 26px 30px rgba(120, 84, 64, 0.16))'
          }} data-id="element-49" data-mp="kbimn60lok7j" />
          </div>

          <div className="mx-auto mt-10 max-w-4xl" data-id="element-50" data-mp="185a7pe5ylfww">
            <ul className="grid gap-6 border-y border-brand-charcoal/10 py-7 sm:grid-cols-3" role="list" data-id="element-51" data-mp="137h66yflpa2y">
              {heroBenefits.map((benefit, index) => {
              const Icon = benefitIcons[index];
              return <li key={benefit.label} className="text-center" data-id="element-52" data-mp="1cyvb5lqbn23h" data-mpi={index}>
                    <Icon className="mx-auto h-5 w-5 text-brand-charcoal/70" strokeWidth={1.25} aria-hidden="true" data-id="element-53" data-mp="1qxbgb88jckji" />
                    <p className="mt-2.5 font-body text-[14px] font-semibold text-brand-charcoal" data-id="element-54" data-mp="1m0cmyrwp4hmd">
                      {benefit.label}
                    </p>
                    <p className="mx-auto mt-1 max-w-[16rem] text-[13px] leading-relaxed text-brand-charcoal/60" data-id="element-55" data-mp="2a2hm4oolgxt4">
                      {benefit.description}
                    </p>
                  </li>;
            })}
            </ul>

            <div id="hero-cta" data-id="element-56" data-mp="2jrhnufuhe7b0">
              <CtaBlock label="Get the Baby Sleep Bible" meta={OFFER_META} className="mt-9" data-id="element-57" data-mp="2juncxv34196q" />
            </div>
          </div>
        </section>

        {/* 02 — PROBLEM */}
        <section aria-labelledby="problem-heading" className="bg-brand-blush px-5 py-14 lg:px-8 lg:py-20" data-id="element-58" data-mp="1r4n79u0sbs2t">
          <div className="mx-auto max-w-2xl text-center" data-id="element-59" data-mp="1w1dlscwxyfm4">
            <h2 id="problem-heading" className="font-display text-[2rem] font-bold leading-[1.12] text-brand-charcoal sm:text-4xl" data-id="element-60" data-mp="212ktyd2zxgtb">
              When Sleep Changes, Everything Changes.
            </h2>
            <p className="mt-4 text-[15px] leading-relaxed text-brand-charcoal/70" data-id="element-61" data-mp="3cgou6106g16t">
              Your baby&apos;s sleep can be unpredictable. You shouldn&apos;t have to start your
              research from zero every time something shifts.
            </p>
          </div>

          <div className="mx-auto mt-10 grid max-w-5xl items-center gap-10 lg:grid-cols-[0.85fr_1.15fr] lg:gap-14" data-id="element-62" data-mp="r41tflrttgl7">
            <img src={LIFESTYLE_URL} alt="A baby sleeping calmly in a quiet, neutral nursery" loading="lazy" decoding="async" className="aspect-[4/5] w-full rounded-[16px] object-cover" data-id="element-63" data-mp="m5i6pj5es0rs" />
            <ul className="border-t border-brand-charcoal/15" role="list" data-id="element-64" data-mp="d4k0qvbetj6k">
              {painPoints.map((pain, index) => {
              const Icon = painIcons[index];
              return <li key={pain} className="flex items-center gap-3.5 border-b border-brand-charcoal/15 py-4" data-id="element-65" data-mp="87a5v0594fbc" data-mpi={index}>
                    <Icon className="h-[18px] w-[18px] flex-none text-brand-charcoal/55" strokeWidth={1.25} aria-hidden="true" data-id="element-66" data-mp="22j8ccuc6ex3j" />
                    <span className="text-[15px] leading-snug text-brand-charcoal" data-id="element-67" data-mp="1xjvqocx1jw2j">{pain}</span>
                  </li>;
            })}
            </ul>
          </div>

          <CtaBlock label="Get Instant Access" className="mx-auto mt-12 max-w-md" data-id="element-68" data-mp="3ryj16wqlznvt" />
        </section>

        {/* 03 — THE SYSTEM */}
        <section aria-labelledby="system-heading" className="bg-brand-ivory px-5 py-14 lg:px-8 lg:py-20" data-id="element-69" data-mp="3i2xtqj2rtveo">
          <div className="mx-auto max-w-6xl" data-id="element-70" data-mp="3n0hgy8hg5iir">
            <div className="mx-auto max-w-2xl text-center" data-id="element-71" data-mp="3mz6i8n2uz0yi">
              <p className="font-body text-[11px] font-medium uppercase tracking-[0.2em] text-brand-charcoal/55" data-id="element-72" data-mp="emh8ndddmzbt">
                The System
              </p>
              <h2 id="system-heading" className="mt-4 font-display text-[2rem] font-bold leading-[1.12] text-brand-charcoal sm:text-4xl" data-id="element-73" data-mp="5kri09rbk4f3">
                One Sleep System. Six Essential Guides.
              </h2>
              <p className="mt-4 text-[15px] leading-relaxed text-brand-charcoal/70" data-id="element-74" data-mp="2qagzkujeq4bh">
                Each guide covers a different challenge and stage, so the system stays with you as
                your baby grows and sleep keeps shifting.
              </p>
            </div>

            <ol className="mt-10 grid gap-x-14 border-t border-brand-charcoal/12 sm:grid-cols-2" data-id="element-75" data-mp="2htzvfautxn4d">
              {guides.map(guide => <li key={guide.number} className="flex items-start gap-4 border-b border-brand-charcoal/12 py-6" data-id="element-76" data-mp="2wrs6nqtcfpcr">
                  <span className="mt-0.5 flex h-9 w-9 flex-none items-center justify-center rounded-full font-body text-[12px] font-semibold text-brand-charcoal" style={{
                backgroundColor: guide.accent
              }} aria-hidden="true" data-id="element-77" data-mp="2rt76tsi077ou">
                    {guide.number}
                  </span>
                  <span data-id="element-78" data-mp="2dt65kbxtty8u">
                    <span className="block font-display text-[1.35rem] font-bold leading-snug text-brand-charcoal" data-id="element-79" data-mp="2duh8k9jg71yw">
                      {guide.title}
                    </span>
                    <span className="mt-1.5 block text-[14px] leading-relaxed text-brand-charcoal/65" data-id="element-80" data-mp="1laior8pv55dk">
                      {guide.description}
                    </span>
                  </span>
                </li>)}
            </ol>
          </div>
        </section>

        {/* 04 — A LOOK INSIDE */}
        <section aria-labelledby="inside-heading" className="bg-brand-paper px-5 py-14 lg:px-8 lg:py-20" data-id="element-81" data-mp="ztafd7oksvf5">
          <div className="mx-auto max-w-6xl" data-id="element-82" data-mp="14qk1oego4qyr">
            <div className="mx-auto max-w-2xl text-center" data-id="element-83" data-mp="18tyj99k99feb">
              <p className="font-body text-[11px] font-medium uppercase tracking-[0.2em] text-brand-charcoal/55" data-id="element-84" data-mp="18rcbp9xd6zw3">
                A Look Inside
              </p>
              <h2 id="inside-heading" className="mt-4 font-display text-[2rem] font-bold leading-[1.12] text-brand-charcoal sm:text-4xl" data-id="element-85" data-mp="1iql43ycl06gc">
                Practical Guidance for Real Life.
              </h2>
              <p className="mt-4 text-[15px] leading-relaxed text-brand-charcoal/70" data-id="element-86" data-mp="1sg4nr684c4c9">
                Clear schedules, practical guidance and easy-reference tools designed for tired
                parents.
              </p>
            </div>

            <div className="mt-10" data-id="element-87" data-mp="21frnlnl79237">
              <InsidePages data-id="element-88" data-mp="3m0eygl298gv5" />
            </div>

            <CtaBlock label="Get All 6 Guides" meta="6 Digital Guides • Instant Access • One-Time Payment" className="mx-auto mt-12 max-w-md border-t border-brand-charcoal/12 pt-10" data-id="element-89" data-mp="3ly26rg6p2s4w" />
          </div>
        </section>

        {/* 05 — TESTIMONIALS */}
        <section aria-labelledby="testimonials-heading" className="bg-brand-blush px-5 py-14 lg:px-8 lg:py-20" data-id="element-90" data-mp="3815kls1ityuc">
          <div className="mx-auto max-w-6xl" data-id="element-91" data-mp="8k7bgslz03i6">
            <h2 id="testimonials-heading" className="text-center font-display text-[2rem] font-bold leading-[1.12] text-brand-charcoal sm:text-4xl" data-id="element-92" data-mp="8n36o96foe2x">
              What Parents Say.
            </h2>
            <div className="mt-10 grid gap-10 sm:grid-cols-3 sm:gap-8" data-id="element-93" data-mp="3vvzvs5wdosyk">
              {testimonials.map(testimonial => <blockquote key={testimonial.name} className="border-t border-brand-charcoal/20 pt-6" data-id="element-94" data-mp="s99980aqksy8">
                  <p className="font-display text-[1.3rem] font-normal italic leading-[1.45] text-brand-charcoal" data-id="element-95" data-mp="nij2ojqkqk1y">
                    “{testimonial.quote}”
                  </p>
                  <footer className="mt-5" data-id="element-96" data-mp="31gcfnw12mtkb">
                    <p className="font-body text-[13px] font-semibold text-brand-charcoal" data-id="element-97" data-mp="2wfygl3hg6tyf">
                      {testimonial.name}
                    </p>
                    <p className="mt-0.5 font-body text-[12px] uppercase tracking-[0.14em] text-brand-charcoal/50" data-id="element-98" data-mp="3aclcr41ktg3a">
                      {testimonial.country}
                    </p>
                  </footer>
                </blockquote>)}
            </div>
          </div>
        </section>

        {/* 06 — FINAL OFFER */}
        <section id="offer" aria-labelledby="offer-heading" className="bg-brand-oatmeal px-5 py-14 lg:px-8 lg:py-20" data-id="element-99" data-mp="3u2nmhof9tqpk">
          <div className="mx-auto max-w-3xl text-center" data-id="element-100" data-mp="3p3kj08exvsjp">
            <p className="font-body text-[11px] font-medium uppercase tracking-[0.2em] text-brand-charcoal/55" data-id="element-101" data-mp="3p66ps5u0a40v">
              The Complete Bundle
            </p>
            <h2 id="offer-heading" className="mt-4 font-display text-[2.2rem] font-bold leading-[1.08] text-brand-charcoal sm:text-[2.6rem]" data-id="element-102" data-mp="20fnfhp7wexs">
              The Baby Sleep Bible
            </h2>

            <div className="relative mx-auto mt-8 w-full max-w-[460px]" data-id="element-103" data-mp="qioiu5y19qsx">
              <div aria-hidden="true" className="absolute left-1/2 top-[56%] h-[60%] w-[84%] -translate-x-1/2 -translate-y-1/2 rounded-[50%] bg-[#E3D3BF] opacity-70 blur-2xl" data-id="element-104" data-mp="ckrlv8fo3idq" />
              <img src={MOCKUP_URL} alt="The Baby Sleep Bible — six digital guides included in the bundle" loading="lazy" decoding="async" className="relative mx-auto block w-full max-w-[320px] object-contain lg:max-w-[420px]" style={{
              filter: 'drop-shadow(0 22px 26px rgba(120, 84, 64, 0.18))'
            }} data-id="element-105" data-mp="2uf1phbrlr84" />
            </div>

            <ul className="mx-auto mt-8 inline-flex flex-col gap-2.5 text-left" role="list" data-id="element-106" data-mp="3u1hsi7noxvht">
              {offerIncludes.map(item => <li key={item} className="flex items-start gap-3 text-[15px] leading-snug text-brand-charcoal/75" data-id="element-107" data-mp="3g1qi0gwdux8k">
                  <span aria-hidden="true" className="mt-2 h-1 w-1 flex-none rounded-full bg-brand-charcoal/40" data-id="element-108" data-mp="3l1up5gbeifm4" />
                  {item}
                </li>)}
            </ul>

            <CtaBlock label="Get the Baby Sleep Bible" meta="One-Time Payment • Instant Digital Access" className="mx-auto mt-9 max-w-md border-t border-brand-charcoal/15 pt-8" data-id="element-109" data-mp="1lrjs6ouqk8r1" />
          </div>
        </section>

        {/* 07 — FAQ */}
        <section aria-labelledby="faq-heading" className="bg-brand-ivory px-5 py-14 lg:px-8 lg:py-20" data-id="element-110" data-mp="29ip2kohwq8ty">
          <div className="mx-auto max-w-3xl" data-id="element-111" data-mp="24jubkz9sddyr">
            <h2 id="faq-heading" className="text-center font-display text-[2rem] font-bold leading-[1.12] text-brand-charcoal sm:text-4xl" data-id="element-112" data-mp="24kvwrwkingu7">
              Questions, Answered.
            </h2>
            <div className="mt-8 border-t border-brand-charcoal/12" data-id="element-113" data-mp="1vi4kjujtgh1i">
              {faqs.map(faq => <FaqItem key={faq.question} {...faq} data-id="element-114" data-mp="p33web11935h" />)}
            </div>
          </div>
        </section>

        {/* Guarantee */}
        <section aria-labelledby="guarantee-heading" className="border-y border-brand-charcoal/10 bg-brand-paper px-5 py-12 lg:px-8" data-id="element-115" data-mp="k2fx722nhg06">
          <div className="mx-auto flex max-w-2xl flex-col items-center text-center" data-id="element-116" data-mp="30q7790n96tmq">
            <ShieldCheckIcon className="h-6 w-6 text-brand-charcoal/60" strokeWidth={1.25} aria-hidden="true" data-id="element-117" data-mp="30ntamncxd9d2" />
            <h2 id="guarantee-heading" className="mt-4 font-display text-[1.6rem] font-bold leading-snug text-brand-charcoal sm:text-[1.9rem]" data-id="element-118" data-mp="39ihh2gu8kx3g">
              {GUARANTEE_TITLE}
            </h2>
            <p className="mt-3 text-[15px] leading-relaxed text-brand-charcoal/70" data-id="element-119" data-mp="3jgouwqt8az18">
              {GUARANTEE_TEXT}
            </p>
          </div>
        </section>
      </main>

      {/* 08 — FOOTER */}
      <footer className="bg-brand-charcoal px-5 pb-36 pt-12 text-brand-ivory/70 md:pb-12 lg:px-8" data-id="element-120" data-mp="3shd8jkepmxdl">
        <div className="mx-auto flex max-w-6xl flex-col gap-6 sm:flex-row sm:items-center sm:justify-between" data-id="element-121" data-mp="1u1qtp5bbxfz3">
          <p className="font-body text-[13px] font-semibold uppercase tracking-[0.22em] text-brand-ivory" data-id="element-122" data-mp="1y32nzo55epdm">
            Prof.Kyra
          </p>
          <nav aria-label="Footer" className="flex flex-wrap gap-x-7 gap-y-2 font-body text-[13px]" data-id="element-123" data-mp="12rkvv1je4pbn">
            <a href="#terms" className="underline-offset-4 transition-colors duration-200 ease-out hover:text-brand-ivory hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-ivory/60" data-id="element-124" data-mp="yr0z3z2qbnq1">
              Terms
            </a>
            <a href="#privacy" className="underline-offset-4 transition-colors duration-200 ease-out hover:text-brand-ivory hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-ivory/60" data-id="element-125" data-mp="k2ek5yh0kxzc">
              Privacy Policy
            </a>
            <a href="#refund" className="underline-offset-4 transition-colors duration-200 ease-out hover:text-brand-ivory hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-ivory/60" data-id="element-126" data-mp="ttsja551zvry">
              Refund Policy
            </a>
            <a href="mailto:profkyra@gmail.com" className="underline-offset-4 transition-colors duration-200 ease-out hover:text-brand-ivory hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-ivory/60" data-id="element-127" data-mp="3sj9c4iw9wxyn">
              Contact
            </a>
          </nav>
        </div>
        <p className="mx-auto mt-8 max-w-6xl font-body text-[12px] leading-relaxed text-brand-ivory/45" data-id="element-128" data-mp="1z0k095vhiqjf">
          © 2026 Prof.Kyra. The Baby Sleep Bible is an educational resource and does not constitute
          medical advice. 7-day money-back guarantee. Payments are processed in your local currency.
        </p>
      </footer>

      <StickyCta data-id="element-129" data-mp="2vp8ctmoflllg" />
    </div>;
}